import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormState {
  isSubmitting: boolean;
  isFormShippingValid: boolean;
  formShippingAddressData: any;
  isNewAddressShippingParts: boolean

}

const initialState: FormState = {
  isSubmitting: false,
  isFormShippingValid: false,
  formShippingAddressData: {},
  isNewAddressShippingParts: false

};

const formShippingAddressSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    triggerIsNewAddressShippingParts: (state, action: PayloadAction<{isValid:boolean}>) => {
      state.isNewAddressShippingParts = action.payload.isValid;
    },

    triggerShippingAddressSubmit: (state) => {
      state.isSubmitting = true;
    },
    setShippingAddressFormValidity: (state, action: PayloadAction<{ isValid: boolean; formData: any }>) => {
      state.isFormShippingValid = action.payload.isValid;
      state.formShippingAddressData = action.payload.formData;
      state.isSubmitting = false; 
    },
    resetFormShippingAddressData: (state) => {
      state.isSubmitting = false;
      state.isFormShippingValid = false;
      state.formShippingAddressData = {};
      state.isNewAddressShippingParts = false
    },
  },
});

export const { triggerShippingAddressSubmit, setShippingAddressFormValidity, triggerIsNewAddressShippingParts, resetFormShippingAddressData } = formShippingAddressSlice.actions;
export default formShippingAddressSlice.reducer;
